import {DeltaEvent, DeltaEventMethodType, UpdateType} from "../../../gd/manager/delta-handler/types"
import createUpdateAction from "../../../gd/manager/delta-handler/session-events-handlers/task/create-update-action"

// const debug = "convertTaskEventToUpdateAction"
const debug = false

export function convertTaskEventToUpdateAction(deltaEvent:DeltaEvent) {

    debug && console.log(debug, 'process', deltaEvent)

    switch (deltaEvent.method) {
        case DeltaEventMethodType.NEW   :
            return createUpdateAction(UpdateType.TASK_NEW, deltaEvent.data)

        case DeltaEventMethodType.DELETE:
            return createUpdateAction(UpdateType.TASK_DELETE, {id: deltaEvent.header.task.id})

        case DeltaEventMethodType.DELTA :
            const deltaData = _.assign({}, deltaEvent.data, {id: deltaEvent.header.task.id})
            return createUpdateAction(UpdateType.TASK_DELTA, deltaData)
    }
}